module.exports = __webpack_public_path__ + "static/media/trex.f83d902c.fset";